export default "__VITE_ASSET__CcQ8K3jx__"